import { useMutation } from "react-query";
import { getVendorsForDownload } from "../../../../actions/CarrierAgreementMgmt/Vendor";

const useGetVendorsForDownload = () => {
  return useMutation(getVendorsForDownload);
};
export default useGetVendorsForDownload;
